<template>
  <div class="left-sidebar">
    <!-- Sidebar scroll-->
    <div class="scroll-sidebar">
      <!-- Sidebar navigation-->
      <nav class="sidebar-nav">
        <ul id="sidebarnav">
          <li class="nav-devider"></li>
           <li class="nav-label">Home</li>
          <li>
            <router-link to="/dashboard" aria-expanded="false">
              <i class="fa fa-tachometer"></i>
              <span class="hide-menu">Dashboard</span>
            </router-link>
          </li>
          <li class="nav-item">
            <div v-if="roleuserModules.includes(3) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#authentifications"
                href="#"
              >
                <i class="fa fa-key"></i>
                <span class="hide-menu">
                  Authentications
                  <span class="label label-rouded label-primary pull-right">4</span>
                </span>
              </a>
              <div class="collapse" id="authentifications" aria-expanded="false">
                <ul>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#roles"
                      class="has-arrow fa fa-gear"
                      href="#"
                    >roles</a>
                    <div id="roles" aria-expanded="false" class="collapse">
                      <ul>
                        <li>
                          <router-link to="/role">
                            <i class="fa fa-hand-o-right"></i> new role
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managerole">
                            <i class="fa fa-hand-o-right"></i> manage roles
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#modules"
                      class="has-arrow fa fa-folder"
                      href="#"
                    >modules</a>
                    <div id="modules" aria-expanded="false" class="collapse">
                      <ul>
                        <li>
                          <router-link to="/newmodule">
                            <i class="fa fa-hand-o-right"></i> new module
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managemodules">
                            <i class="fa fa-hand-o-right"></i> manage modules
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#permissions"
                      class="has-arrow fa fa-key"
                      href="#"
                    >permissions</a>
                    <div id="permissions" aria-expanded="false" class="collapse">
                      <ul>
                        <li>
                          <router-link to="/permission">
                            <i class="fa fa-hand-o-right"></i> new permission
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managepermissions">
                            <i class="fa fa-hand-o-right"></i> manage permissions
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#users"
                      class="has-arrow fa fa-users"
                      href="#"
                    >system users</a>
                    <div id="users" aria-expanded="false" class="collapse">
                      <ul>
                        <li>
                          <router-link to="/newuser">
                            <i class="fa fa-hand-o-right"></i> new user
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/manageusers">
                            <i class="fa fa-hand-o-right"></i> manage users
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(5) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#CustomerSettings"
                href="#"
              >
                <i class="fa fa-users"></i>
                <span class="hide-menu">Customers</span>
                <span class="label label-rouded label-primary pull-right">2</span>
              </a>
              <div class="collapse" id="CustomerSettings" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/newcustomer">
                      <i class="fa fa-hand-o-right"></i> new customer
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managecustomers">
                      <i class="fa fa-hand-o-right"></i> manage customers
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(7) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Shippinglines"
                href="#"
              >
                <i class="fa fa-ship"></i>
                <span class="hide-menu">Shippinglines</span>
                <span class="label label-rouded label-primary pull-right">2</span>
              </a>
              <div class="collapse" id="Shippinglines" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/newshippingline">
                      <i class="fa fa-hand-o-right"></i> new shippingline
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/manageshippinglines">
                      <i class="fa fa-hand-o-right"></i> manage shippinglines
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(8) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Transporters"
                href="#"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">Transporters</span>
                <span class="label label-rouded label-primary pull-right">2</span>
              </a>
              <div class="collapse" id="Transporters" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/newtransporter">
                      <i class="fa fa-hand-o-right"></i> new transporter
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managetransporters">
                      <i class="fa fa-hand-o-right"></i> manage transporters
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managetrucks">
                      <i class="fa fa-hand-o-right"></i> manage trucks
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(9) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Fileopenings"
                href="#"
              >
                <i class="fa fa-file"></i>
                <span class="hide-menu">File opening</span>
                <span class="label label-rouded label-primary pull-right">1</span>
              </a>
              <div class="collapse" id="Fileopenings" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/managecustomerfiles">
                      <i class="fa fa-hand-o-right"></i> new file
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managefileopenings">
                      <i class="fa fa-hand-o-right"></i> manage fileopenings
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(10) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#CargoEntries"
                href="#"
              >
                <i class="fa fa-ship"></i>
                <span class="hide-menu">Cargo Entries</span>
                <span class="label label-rouded label-primary pull-right">1</span>
              </a>
              <div class="collapse" id="CargoEntries" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/managecargoentries">
                      <i class="fa fa-hand-o-right"></i> manage cargoentries
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(11) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#ShippingDepartment"
                href="#"
              >
                <i class="fa fa-ship"></i>
                <span class="hide-menu">Shipping department</span>
                <span class="label label-rouded label-primary pull-right">2</span>
              </a>
              <div class="collapse" id="ShippingDepartment" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/manageShippingdepartment">
                      <i class="fa fa-hand-o-right"></i> new shipping
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/manageShippingdepartments">
                      <i class="fa fa-hand-o-right"></i> manage Shipping
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(12) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#hasRoleModuleCustomReleases"
                href="#"
              >
                <i class="fa fa-ship"></i>
                <span class="hide-menu">customs department</span>
                <span class="label label-rouded label-primary pull-right">2</span>
              </a>
              <div class="collapse" id="hasRoleModuleCustomReleases" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/managecustomrelease">
                      <i class="fa fa-hand-o-right"></i> new customrelease
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managecustomreleases">
                      <i class="fa fa-hand-o-right"></i> manage customrelease
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(13) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#BondDepartment"
                href="#"
              >
                <i class="fa fa-money"></i>
                <span class="hide-menu">Bond department</span>
                <span class="label label-rouded label-primary pull-right">2</span>
              </a>
              <div class="collapse" id="BondDepartment" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/managecustombonds">
                      <i class="fa fa-hand-o-right"></i> new bond
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/managebonds">
                      <i class="fa fa-hand-o-right"></i> manage bonds
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(14) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#TruckAllocation"
                href="#"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">Truck allocation</span>
                <span class="label label-rouded label-primary pull-right">1</span>
              </a>
              <div class="collapse" id="TruckAllocation" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/managerequisitions">
                      <i class="fa fa-hand-o-right"></i> manage truck allocation
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(15) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#BondTracking"
                href="#"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">Bond tracking</span>
                <span class="label label-rouded label-primary pull-right">1</span>
              </a>
              <div class="collapse" id="BondTracking" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/managebondtrackings">
                      <i class="fa fa-hand-o-right"></i> manage bond tracking
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(16) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#TruckTracking"
                href="#"
              >
                <i class="fa fa-truck"></i>
                <span class="hide-menu">Truck tracking</span>
                <span class="label label-rouded label-primary pull-right">1</span>
              </a>
              <div class="collapse" id="TruckTracking" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/managetrucktrackings">
                      <i class="fa fa-hand-o-right"></i> manage truck tracking
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(18) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Reports"
                href="#"
              >
                <i class="fa fa-file-pdf-o"></i>
                <span class="hide-menu">Reports</span>
                <span class="label label-rouded label-primary pull-right">5</span>
              </a>
              <div class="collapse" id="Reports" aria-expanded="false">
                <ul>
                  <li>
                    <router-link to="/fileopeneddate">
                      <i class="fa fa-hand-o-right"></i> Fileopened
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/dailyexpenses">
                      <i class="fa fa-hand-o-right"></i> Daily expenses
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/weeklyexpenses">
                      <i class="fa fa-hand-o-right"></i> Weekly expenses
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/monthlyexpenses">
                      <i class="fa fa-hand-o-right"></i> Monthly expenses
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/cashaccount">
                      <i class="fa fa-hand-o-right"></i> cash statement
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="roleuserModules.includes(19) === true">
              <a
                class="nav-link collapsed has-arrow anchorColros"
                data-toggle="collapse"
                data-target="#Accounts"
                href="#"
              >
                <i class="fa fa-money"></i>
                <span class="hide-menu">Accounts</span>
                <span class="label label-rouded label-primary pull-right">5</span>
              </a>
              <div class="collapse" id="Accounts" aria-expanded="false">
                <ul>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#pettycashes"
                      class="has-arrow fa fa-money"
                      href="#"
                    >Petty cash allocation</a>
                    <div class="collapse" id="pettycashes" aria-expanded="false">
                      <ul>
                        <li>
                          <router-link to="/newpettycash">
                            <i class="fa fa-hand-o-right"></i> new petty cash
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/managepettycashes">
                            <i class="fa fa-hand-o-right"></i> manage pettycash
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#accounttypes"
                      class="has-arrow fa fa-money"
                      href="#"
                    >Account types</a>
                    <div class="collapse" id="accounttypes" aria-expanded="false">
                      <ul>
                        <li>
                          <router-link to="/newaccount">
                            <i class="fa fa-hand-o-right"></i> new account
                          </router-link>
                        </li>

                        <li>
                          <router-link to="/manageaccounttypes">
                            <i class="fa fa-hand-o-right"></i> manage accounttypes
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#pettyaccounts"
                      class="has-arrow fa fa-money"
                      href="#"
                    >Petty account</a>
                    <div class="collapse" id="pettyaccounts" aria-expanded="false">
                      <ul>
                        <li>
                          <router-link to="/pettyaccount">
                            <i class="fa fa-hand-o-right"></i> new account
                          </router-link>
                        </li>

                        <li>
                          <router-link to="/managepettyaccounts">
                            <i class="fa fa-hand-o-right"></i> manage account
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#dailytransactions"
                      class="has-arrow fa fa-money"
                      href="#"
                    >Daily transactions</a>
                    <div class="collapse" id="dailytransactions" aria-expanded="false">
                      <ul>
                        <li>
                          <router-link to="/newtransaction">
                            <i class="fa fa-hand-o-right"></i> new transaction
                          </router-link>
                        </li>

                        <li>
                          <router-link to="/managedailytransactions">
                            <i class="fa fa-hand-o-right"></i> manage dailytransactions
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li>
                    <a
                      data-toggle="collapse"
                      data-target="#invoices"
                      class="has-arrow fa fa-money"
                      href="#"
                    >Invoicing</a>
                    <div class="collapse" id="invoices" aria-expanded="false">
                      <ul>
                        <li>
                          <router-link to="/managefileinvoicing">
                            <i class="fa fa-hand-o-right"></i> new invoice
                          </router-link>
                        </li>
                        <li>
                          <router-link to="/manageinvoices">
                            <i class="fa fa-hand-o-right"></i> manage invoices
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </nav>
      <!-- End Sidebar navigation -->
    </div>
    <!-- End Sidebar scroll-->
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["roleuserModules"])
};
</script>


// WEBPACK FOOTER //
// src/layouts/sidebar.vue